import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { UpdateCardRequestDto, UpdateCardResponseDto } from '../model';

const updateCard = async (
  templateId: string,
  args: UpdateCardRequestDto,
  options?: RequestHandlerOptions
): Promise<UpdateCardResponseDto> => {
  const request = () =>
    apiClient.patch(`/operations/card/template/${templateId}`, args);

  const response = await handleRequest<UpdateCardResponseDto>(request, options);

  return response.data;
};

const deleteCard = async (
  templateId: string,
  options?: RequestHandlerOptions
): Promise<void> => {
  const request = () =>
    apiClient.delete(`/operations/card/template/${templateId}`);
  const response = await handleRequest<void>(request, options);
  return response.data;
};

export { updateCard, deleteCard };
